import { useQuery } from '@tanstack/react-query';
import { menuItemRequests, type MenuItemSearchParams } from '@/lib/api/requests/menu-items';
import { menuItemKeys } from './keys';

export function useMenuItems(params?: MenuItemSearchParams, enabled = true) {
  return useQuery({
    queryKey: menuItemKeys.list(params),
    queryFn: () => menuItemRequests.list(params),
    enabled,
    placeholderData: (previousData) => previousData,
  });
}

export function useMenuItem(id: number, enabled = true) {
  return useQuery({
    queryKey: menuItemKeys.detail(id),
    queryFn: () => menuItemRequests.getById(id),
    enabled: !!id && enabled,
  });
}

export function useMenusForItems(enabled = true, companyId?: number) {
  return useQuery({
    queryKey: [...menuItemKeys.menus(), companyId ?? null],
    queryFn: () => menuItemRequests.listMenus({ companyId }),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
